// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, isSupported } from "firebase/messaging";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyChFTcmW3Cpvcj0FfqLtol7ma6SNXTcycM",
  authDomain: "tcpcanvasser.firebaseapp.com",
  projectId: "tcpcanvasser",
  storageBucket: "tcpcanvasser.firebasestorage.app",
  messagingSenderId: "1086897288169",
  appId: "1:1086897288169:web:8f72f61d1bd75abc689178",
  measurementId: "G-3805CC3GF1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

let analytics = null;
try {
  analytics = getAnalytics(app);
} catch (e) {
  console.warn('Firebase Analytics not supported on this browser:', e.message);
}

// isSupported() is the authoritative async check Firebase provides.
// It prevents the internal unsupported-browser promise rejection that
// getMessaging() can emit asynchronously on iOS Safari and similar environments.
let messaging = null;
const messagingReady = isSupported()
  .then((supported) => {
    if (!supported) return null;
    try {
      messaging = getMessaging(app);
      return messaging;
    } catch (e) {
      console.warn('Firebase Messaging init failed:', e.message);
      return null;
    }
  })
  .catch((e) => {
    console.warn('Firebase Messaging not supported on this browser:', e.message);
    return null;
  });

export { messaging, messagingReady };